import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'cdba-auth-callback',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: '',
})
export class AuthCallbackComponent {
  private readonly router = inject(Router);

  constructor() {
    // MsalRedirectComponent (bootstrapped in app.module) handles the auth code processing
    // Give it time to complete, then navigate to search
    setTimeout(() => {
      this.router.navigate(['/search']);
    }, 500);
  }
}
